import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../config/axiosConfig";
import config from "../../config/api";

const BackendURL = config.backendUrl;

export const fetchCompanyProfiles = createAsyncThunk(
  'companyProfile/fetchAll',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`${BackendURL}/companyprofile/getall`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const createCompanyProfile = createAsyncThunk(
  'companyProfile/create',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(`${BackendURL}/companyprofile/create`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const saveOrUpdateCompanyProfile = createAsyncThunk(
  'companyProfile/saveOrUpdate',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(
        `${BackendURL}/companyprofile/update`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const updateCompanyProfile = createAsyncThunk(
  'companyProfile/update',
  async ({ id, formData }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(`${BackendURL}/companyprofile/update/${id}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const deleteCompanyProfile = createAsyncThunk(
  'companyProfile/delete',
  async (id, { rejectWithValue }) => {
    try {
      await axiosInstance.delete(`${BackendURL}/companyprofile/delete/${id}`);
      return id;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const companyProfileSlice = createSlice({
  name: 'companyProfile',
  initialState: {
    profiles: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCompanyProfiles.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCompanyProfiles.fulfilled, (state, action) => {
        state.loading = false;
        const p = action.payload;
        state.profiles = Array.isArray(p)
          ? p
          : p?.data && Array.isArray(p.data)
            ? p.data
            : p && typeof p === "object" && (p._id != null || p.companyname != null)
              ? [p]
              : [];
      })
      .addCase(fetchCompanyProfiles.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(createCompanyProfile.fulfilled, (state, action) => {
        state.profiles.push(action.payload);
      })
      .addCase(createCompanyProfile.rejected, (state, action) => {
        state.error = action.payload;
      })

      .addCase(updateCompanyProfile.fulfilled, (state, action) => {
        const index = state.profiles.findIndex(p => p._id === action.payload._id);
        if (index !== -1) state.profiles[index] = action.payload;
      })
      .addCase(updateCompanyProfile.rejected, (state, action) => {
        state.error = action.payload;
      })

      .addCase(deleteCompanyProfile.fulfilled, (state, action) => {
        state.profiles = state.profiles.filter(p => p._id !== action.payload);
      })
      .addCase(deleteCompanyProfile.rejected, (state, action) => {
        state.error = action.payload;
      })

      .addCase(saveOrUpdateCompanyProfile.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(saveOrUpdateCompanyProfile.fulfilled, (state, action) => {
        state.loading = false;

        const index = state.profiles.findIndex(p => p._id === action.payload._id);
        if (index !== -1) {
          state.profiles[index] = action.payload; // update existing
        } else {
          state.profiles.push(action.payload); // create new
        }
      })
      .addCase(saveOrUpdateCompanyProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

  }
});

export default companyProfileSlice.reducer;
